<template>
    <div class="input-container" :class="label ? 'input-container-with-label' : ''">
        <div class="input-label-container">
            <!-- <form-label-title v-if="label" :label="label" :isRequired="isRequired"></form-label-title> -->
            <!-- <p class="input-label" v-if="label">{{label}}</p> -->
            <el-checkbox v-model="checked" :size="size" @change="handleChange($event)">{{ inputLabel }}</el-checkbox>
            <slot />
        </div>
    </div>
</template>

<script>
import FormLabelTitle from "./FormLabelTitle";

export default {
    components: {
        "form-label-title": FormLabelTitle,
    },
    props: {
        inputValue: {
            type: String | Number | Boolean,
            default: false
        },
        label: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: "small"
        },
        isRequired: {
            type: Boolean
        }
    },
    computed: {
        inputLabel() {
            if (this.label) {
                let name = this.label;
                let requiredSymbol = this.isRequired ? "*" : "";
                return `${name}${requiredSymbol}`;
            }
            else return "";
        },
        checked: {
            set(val) {
                this.$emit("update:inputValue", val);
            },
            get() {
                return this.inputValue;
            }
        }
    },
    methods: {
        handleChange(value) {
            this.$emit("handleChange", value);
        }
    },
};
</script>

<style lang="css" scoped>
.input-label-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FormCheckbox.vue